import { FormControl, FormLabel } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';
import TextField from '@mui/material/TextField';
import { forwardRef } from 'react';
import { LabelTooltip } from '~/components/molecules/LabelTooltip';

export type TextInputProps = TextFieldProps & {
  id: Required<TextFieldProps['id']>; // ID is required to avoid Hydration errors in MUI form fields
  tooltip?: string;
};

const TextInput = forwardRef<HTMLDivElement, TextInputProps>(({ label, tooltip, ...props }, ref) => {
  return (
    <FormControl error={props.error} fullWidth>
      {label && (
        <FormLabel color="secondary" htmlFor={props.id} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {label}
          <LabelTooltip text={tooltip} />
        </FormLabel>
      )}
      <TextField
        size="small"
        fullWidth
        sx={({ spacing, typography }) => ({
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
          },
          '& .MuiInputBase-input': {
            px: spacing(1.5),
            py: spacing(1),
            fontSize: typography.body1.fontSize,
            lineHeight: `calc(${typography.body1.fontSize} * 1.25)`,
            height: `calc(${typography.body1.fontSize} * 1.25)`,
          },
        })}
        {...props}
        ref={ref}
      />
    </FormControl>
  );
});

TextInput.displayName = 'TextInput';
export { TextInput };
